module.exports = __webpack_public_path__ + "6284844436673603052c28ea5c471c5c.pdf";